/* assets/custom.js — vanilla JS rewrite (Phase 11.8, 2026-05-01).
   Drops jQuery dependency. Preserves all prior behavior:
     - copy() helper (called from inline onclick)
     - ul.tabs anchor-based tab system (first DOMContentLoaded ready block)
     - .read-more → scroll to .additionalTab
     - .cross → hide .bar-announce
     - .addtional-info h3 → slideToggle .info-part
     - .additionalTab .mobile-tab toggle (≤767px)
     - .popUpBtn / span.close / window-click modal handlers
     - .tab_content / .tab_drawer_heading tab system (rel-attribute based)
     - .footer-block__heading mobile accordion (≤767px)
     - .set > a accordion
     - .copy-text → copy-to-clipboard
     - div.rating-value-title → scroll to judgeme reviews
     - .benefits-content_wrap scroll-driven animation
     - phone-field digits-only enforcement
*/

function copy() {
  var e = document.getElementById("copyClipboard");
  var t = document.getElementById("copied-success");
  if (!e || !t) return;
  e.select();
  e.setSelectionRange(0, 99999);
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(e.value);
  }
  t.style.opacity = "1";
  setTimeout(function () { t.style.opacity = "0"; }, 500);
}

(function () {
  // jQuery slide* equivalents (height-based, 250ms default)
  function slideDown(el, dur) {
    if (!el) return;
    dur = dur || 400;
    el.style.removeProperty('display');
    var disp = window.getComputedStyle(el).display;
    if (disp === 'none') disp = 'block';
    el.style.display = disp;
    var h = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.transition = 'height ' + dur + 'ms ease';
    requestAnimationFrame(function () { el.style.height = h + 'px'; });
    setTimeout(function () {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, dur);
  }
  function slideUp(el, dur) {
    if (!el) return;
    dur = dur || 400;
    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
    el.style.transition = 'height ' + dur + 'ms ease';
    requestAnimationFrame(function () { el.style.height = '0px'; });
    setTimeout(function () {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
    }, dur);
  }
  function slideToggle(el, dur) {
    if (!el) return;
    if (window.getComputedStyle(el).display === 'none') slideDown(el, dur);
    else slideUp(el, dur);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // 1. ul.tabs anchor-based tab system (first ready block; coexists with #2 below).
    document.querySelectorAll('ul.tabs').forEach(function (tabsEl) {
      var lis = tabsEl.querySelectorAll('li');
      if (!lis.length) return;
      var firstLi = lis[0];
      firstLi.classList.add('active');
      var hrefOf = function (li) { return li.getAttribute('href') || (li.querySelector('a') && li.querySelector('a').getAttribute('href')) || null; };
      var firstHref = hrefOf(firstLi);
      var activeContent = firstHref ? document.querySelector(firstHref) : null;
      var activeLi = firstLi;
      lis.forEach(function (li, i) {
        if (i === 0) return;
        var href = hrefOf(li);
        var t = href ? document.querySelector(href) : null;
        if (t) t.style.display = 'none';
      });
      lis.forEach(function (li) {
        li.addEventListener('click', function (e) {
          e.preventDefault();
          if (activeLi) activeLi.classList.remove('active');
          if (activeContent) activeContent.style.display = 'none';
          activeLi = li;
          var href = hrefOf(li);
          activeContent = href ? document.querySelector(href) : null;
          activeLi.classList.add('active');
          if (activeContent) activeContent.style.display = '';
        });
      });
    });

    // 2. .read-more → scroll to .additionalTab
    document.querySelectorAll('.read-more').forEach(function (el) {
      el.addEventListener('click', function () {
        var target = document.querySelector('.additionalTab');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    // 3. .cross → hide .bar-announce
    document.querySelectorAll('.cross').forEach(function (el) {
      el.addEventListener('click', function () {
        document.querySelectorAll('.bar-announce').forEach(function (b) { b.style.display = 'none'; });
      });
    });

    // 4. .addtional-info h3 → slideToggle .info-part
    document.querySelectorAll('.addtional-info h3').forEach(function (h3) {
      h3.addEventListener('click', function () {
        document.querySelectorAll('.info-part').forEach(function (p) { slideToggle(p); });
      });
    });

    // 5. Mobile additionalTab .mobile-tab toggle (≤767px at load)
    if (window.innerWidth < 767) {
      var addTab = document.querySelector('.additionalTab');
      if (addTab) {
        addTab.querySelectorAll('.mobile-tab').forEach(function (tab) {
          tab.addEventListener('click', function () {
            var wasActive = tab.classList.contains('active');
            addTab.querySelectorAll('.mobile-tab').forEach(function (t) { t.classList.remove('active'); });
            if (!wasActive) tab.classList.add('active');
            var next = tab.nextElementSibling;
            if (next) slideToggle(next, 200);
            addTab.querySelectorAll('.tabcontent').forEach(function (c) {
              if (c !== next) slideUp(c, 200);
            });
          });
        });
      }
    }

    // 6. Modal popup buttons + close + click-outside
    document.querySelectorAll('.popUpBtn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.modal;
        var modal = id ? document.getElementById(id) : null;
        if (modal) modal.style.display = 'block';
      });
    });
    document.querySelectorAll('span.close').forEach(function (c) {
      c.addEventListener('click', function () {
        document.querySelectorAll('.modal').forEach(function (m) { m.style.display = 'none'; });
      });
    });
    window.addEventListener('click', function (e) {
      document.querySelectorAll('.modal').forEach(function (m) {
        if (e.target === m) m.style.display = 'none';
      });
    });

    // 7. .tab_content / .tab_drawer_heading rel-based tab system (second ul.tabs handler).
    var tabContents = document.querySelectorAll('.tab_content');
    tabContents.forEach(function (c, i) { c.style.display = i === 0 ? '' : 'none'; });
    document.querySelectorAll('ul.tabs li').forEach(function (li) {
      li.addEventListener('click', function () {
        document.querySelectorAll('.tab_content').forEach(function (c) { c.style.display = 'none'; });
        var rel = li.getAttribute('rel');
        if (rel) {
          var target = document.getElementById(rel);
          if (target) target.style.display = '';
        }
        document.querySelectorAll('ul.tabs li').forEach(function (x) { x.classList.remove('active'); });
        li.classList.add('active');
        document.querySelectorAll('.tab_drawer_heading').forEach(function (h) { h.classList.remove('d_active'); });
        if (rel) document.querySelectorAll('.tab_drawer_heading[rel^="' + rel + '"]').forEach(function (h) { h.classList.add('d_active'); });
      });
    });
    var tabsHostEl = document.querySelector('.tabs');
    if (tabsHostEl) {
      document.querySelectorAll('.tab_container').forEach(function (c) {
        c.style.minHeight = (tabsHostEl.offsetHeight + 50) + 'px';
      });
    }
    document.querySelectorAll('.tab_drawer_heading').forEach(function (h) {
      h.addEventListener('click', function () {
        var next = h.nextElementSibling;
        var isVisible = next && window.getComputedStyle(next).display !== 'none';
        if (isVisible) {
          slideUp(next);
        } else {
          document.querySelectorAll('.tab_content').forEach(function (c) { slideUp(c); });
          slideDown(next);
        }
        document.querySelectorAll('.tab_drawer_heading').forEach(function (x) { x.classList.remove('d_active'); });
        h.classList.add('d_active');
        var id = next ? next.id : '';
        document.querySelectorAll('ul.tabs li').forEach(function (x) { x.classList.remove('active'); });
        if (id) document.querySelectorAll('ul.tabs li[rel^="' + id + '"]').forEach(function (x) { x.classList.add('active'); });
      });
    });

    // 8. .footer-block__heading mobile accordion (≤767px at load)
    if (window.innerWidth < 767) {
      document.querySelectorAll('.footer-block__heading').forEach(function (h) {
        h.addEventListener('click', function () {
          var isActive = h.classList.contains('active');
          var sibling = h.parentElement && h.parentElement.querySelector('.footer-block__details-content');
          if (isActive) {
            h.classList.remove('active');
            if (sibling) slideUp(sibling, 200);
          } else {
            document.querySelectorAll('.footer-block__heading').forEach(function (x) { x.classList.remove('active'); });
            h.classList.add('active');
            document.querySelectorAll('.footer-block__details-content').forEach(function (s) { slideUp(s, 200); });
            if (sibling) slideDown(sibling, 200);
          }
        });
      });
    }

    // 9. .set > a accordion
    document.querySelectorAll('.set > a').forEach(function (a) {
      a.addEventListener('click', function () {
        var isActive = a.classList.contains('active');
        var content = a.parentElement && a.parentElement.querySelector('.content');
        if (isActive) {
          a.classList.remove('active');
          if (content) slideUp(content, 200);
        } else {
          document.querySelectorAll('.set > a').forEach(function (x) { x.classList.remove('active'); });
          a.classList.add('active');
          document.querySelectorAll('.set .content').forEach(function (c) { slideUp(c, 200); });
          if (content) slideDown(content, 200);
        }
      });
    });

    // 10. .copy-text → copy-to-clipboard with .active flash
    var copyText = document.querySelector('.copy-text');
    if (copyText) {
      var clipInput = copyText.querySelector('.clipboard > input');
      var textInput = copyText.querySelector('input.text');
      if (clipInput && textInput) {
        clipInput.addEventListener('click', function () {
          textInput.select();
          document.execCommand('copy');
          copyText.classList.add('active');
          if (window.getSelection) window.getSelection().removeAllRanges();
          setTimeout(function () { copyText.classList.remove('active'); }, 2500);
        });
      }
    }

    // 11. div.rating-value-title → scroll to judgeme reviews
    document.querySelectorAll('div.rating-value-title').forEach(function (el) {
      el.addEventListener('click', function () {
        var target = document.getElementById('judgeme_product_reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    // 12. .benefits-content_wrap scroll-driven animation (draws .draw-line, marks .in-view).
    //     2026-05-13: RAF-throttled. Was: unthrottled scroll listener with per-item
    //     getBoundingClientRect() — layout-thrashing on every scroll event.
    var drawLine = document.querySelector('.draw-line');
    if (drawLine) {
      var wrap = document.querySelector('.benefits-content_wrap');
      var defaultLine = document.querySelector('.default-line');
      var wrapOuter = document.querySelector('.benefits-content_wrap-outer');
      var items = document.querySelectorAll('.benefits-content_item');
      if (wrap && defaultLine) defaultLine.style.height = wrap.offsetHeight + 'px';
      var ticking = false;
      function onBenefitsScroll() {
        if (!wrapOuter || !defaultLine) return;
        // Read phase — all reflow reads grouped together.
        var scrollY = window.scrollY || window.pageYOffset;
        var thresh = window.innerHeight / 1.2;
        var wrapTop = wrapOuter.getBoundingClientRect().top + scrollY;
        var itemHeight = defaultLine.offsetHeight;
        var lineRect = drawLine.getBoundingClientRect();
        var lineBottom = lineRect.top + lineRect.height + scrollY;
        // Cache each item's top BEFORE any DOM writes, so subsequent writes
        // don't force a re-layout mid-loop.
        var itemPositions = [];
        items.forEach(function (item) {
          itemPositions.push(item.getBoundingClientRect().top + scrollY);
        });
        // Write phase.
        if (scrollY >= wrapTop - thresh) {
          var line = scrollY - wrapTop + thresh;
          if (line <= itemHeight) drawLine.style.height = line + 'px';
        }
        items.forEach(function (item, idx) {
          if (lineBottom > itemPositions[idx]) item.classList.add('in-view');
          else item.classList.remove('in-view');
        });
      }
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          onBenefitsScroll();
          ticking = false;
        });
      }, { passive: true });
    }
  });
})();

// Phone-field digits-only enforcement
['ContactForm-phone', 'contactFormPhone', 'Phonefield'].forEach(function (id) {
  var el = document.getElementById(id);
  if (el) {
    el.addEventListener('input', function (e) {
      e.target.value = e.target.value.replace(/\D/g, '');
    });
  }
});
